module.exports = __webpack_public_path__ + "img/policia_municipal_down_selected.ccc897a7.svg";